import { Outlet } from '@tanstack/react-router'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { CommandPalette } from '@/components/CommandPalette'
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { useFilterStore } from '@/stores/filters'
import { cn } from '@/lib/utils'

export function AdminLayout() {
  const sidebarCollapsed = useFilterStore((s) => s.sidebarCollapsed)
  useKeyboardShortcuts()

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <CommandPalette />
      <div
        className={cn(
          'flex flex-col transition-all duration-200',
          sidebarCollapsed ? 'ml-16' : 'ml-60'
        )}
      >
        <TopBar />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
